var PageAuth = (function () {
    function PageAuth() {
        this.Auth = {};
    }
    return PageAuth;
}());
export { PageAuth };
